import { render, staticRenderFns } from "./SingleStand.vue?vue&type=template&id=1187590a&scoped=true&"
import script from "./SingleStand.vue?vue&type=script&lang=js&"
export * from "./SingleStand.vue?vue&type=script&lang=js&"
import style0 from "./SingleStand.vue?vue&type=style&index=0&id=1187590a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187590a",
  null
  
)

export default component.exports